import { useState, useEffect } from 'react';
import { IAccountRoleTypeOptions } from '@/models/account/types';
import { isLiveEventOrganizer } from '@/utils/helpers';
import useRegistrationConditionFieldShowValidation from '@/hooks/use-registration-condition-field-show-validation';

const useRegistrationRequiredFieldValidation = (
  eventRoleId,
  role,
  currentUserEventPermissions,
  registrationCustomFieldList,
  currentUser,
  eventLandingPageDisclaimers,
  event,
  isLoginFlowOnly,
) => {
  const [
    shouldUpdatePendingCustomFields,
    setShouldUpdatePendingCustomFields,
  ] = useState(false);

  const { getFilteredConditionalFieldsAccordingToLogic } = useRegistrationConditionFieldShowValidation(null, null);

  useEffect(() => {
    if (isLoginFlowOnly) {
      setShouldUpdatePendingCustomFields(false);
      return;
    }
    if (!eventRoleId || !event) {
      return;
    }

    if (event.seriesParentEventId) {
      setShouldUpdatePendingCustomFields(false);
      return;
    }

    if(currentUser?.isGuestAccount) {
      return;
    }

    if (
      role === IAccountRoleTypeOptions.SPEAKER ||
      isLiveEventOrganizer(role)
    ) {
      return;
    }

    const custom =
      currentUserEventPermissions && currentUserEventPermissions?.customField;

    let filteredFields = getFilteredConditionalFieldsAccordingToLogic(custom && JSON.parse(custom), registrationCustomFieldList);

    const customMandatoryFields =
    filteredFields &&
    filteredFields.filter(field => field.isRequired);

    //Custom fields check
    customMandatoryFields &&
      customMandatoryFields.map(field => {
        if (field.isPredefinedField) {
          if (!currentUser[field.labelName]) {
            setShouldUpdatePendingCustomFields(true);
            return;
          }
        } else if (custom && !custom.includes(field.labelName)) {
          setShouldUpdatePendingCustomFields(true);
          return;
        }
      });

    //Disclaimer check
    eventLandingPageDisclaimers.map(disclaimer => {
      if (disclaimer.requestConsent && disclaimer.isConsentMandatory) {
        if (!custom) {
          setShouldUpdatePendingCustomFields(true);
          return;
        }

        const customDisclaimers = JSON.parse(custom);
        if (!customDisclaimers?.disclaimers) {
          setShouldUpdatePendingCustomFields(true);
          return;
        }
        if (
          customDisclaimers.disclaimers &&
          customDisclaimers.disclaimers?.length === 0
        ) {
          setShouldUpdatePendingCustomFields(true);
          return;
        }

        let disclaimerChecked = false;
        customDisclaimers.disclaimers.map(item => {
          if (item.text === disclaimer.text) {
            disclaimerChecked = true;
          }
        });
        if (!disclaimerChecked) {
          setShouldUpdatePendingCustomFields(true);
        }
      }
    });
  }, [
    registrationCustomFieldList,
    currentUserEventPermissions?.customField,
    event,
    isLoginFlowOnly,
  ]);

  return shouldUpdatePendingCustomFields;
};

export default useRegistrationRequiredFieldValidation;
